import {pspRequestService} from "@/common/api.service";

const initialStates = {
    status: 'loading',
    form_data: {
        user_name: '',
        full_name: '',
        show_phone_number: '',
        phone_number: '',
        wage_type: '',
        terminal_id: '',
        fa_gateway_name: '',
        description: '',
        user_found: ''
    }
}

const mutations = {

    loading(state) {
        state.status    = 'loading'
    },
    success(state, form_data) {
        state.status    = 'success'
        state.form_data = form_data
    },
    fail(state) {
        state.status    = 'fail'
        state.form_data = []
    },
    setFormData(state, form_data) {
        state.status    = 'setFormData'
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key){
            state.form_data[key] = ''
        });
    }
}

const getters = {
    status: ({status}) => status,
    form_data: ({form_data}) => form_data
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return pspRequestService.fetch().then(response => {
            commit('success', response.data.data)
        })
    },
    find({commit}, hashid) {
        commit('loading')
        return pspRequestService.find(hashid).then(response => {
            commit('setFormData', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}